

// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function($) {
    // var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            // 慣性スクロール（Lenis）が有効な時はLenis側で移動させる // Let Lenis handle the move while inertia scrolling is enabled
            if (window.lenis) {
                window.lenis.scrollTo(target.get(0), {offset: -headerHeight, force: true});
            } else {
                var position = target.offset().top - headerHeight;
                $("html, body").animate({scrollTop:position}, 550, "swing");
            }
            return false;
        }
    });
})



// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function($) {
	var $header = $('header');
	// TOPページのFV。ここを過ぎてからヘッダーのロゴを出す
	// The front page hero: the header logo appears only after it has scrolled past
	var $fv = $('.p-frontFv');
	var threshold = 100;

	function updateThreshold() {
		// TOPページはFVの下端、それ以外のページは100pxを基準にする
		// Front page uses the bottom of the hero, other pages use 100px
		if ($fv.length > 0) {
			threshold = $fv.offset().top + $fv.outerHeight() - $header.innerHeight();
		} else {
			threshold = 100;
		}
	}

	function toggleFixed() {
		if ($(window).scrollTop() > threshold) {
			$header.addClass('fixed');
		} else {
			$header.removeClass('fixed');
		}
	}

	function update() {
		updateThreshold();
		toggleFixed();
	}

	// 読み込み時のスクロール位置でも判定する（リロード時にナビが消えたままにならないように）
	// Also check on load so the nav is not left hidden after a reload
	update();
	$(window).on('load resize', update);
	$(window).on('scroll', toggleFixed);
});



// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 200);
		});
	}
});


// エンジニアの仕事カード：クリックで本文を開閉 // Toggle the engineer work card body on click
jQuery(function ($) {

	var $cards = $('.js-workCard');

	if (!$cards.length) {
		return;
	}

	// 表示の切り替えは --open のCSSだけで行う（アニメーションなし）
	var toggle = function ($card) {
		var willOpen = !$card.hasClass('--open');

		$card.toggleClass('--open', willOpen).attr('aria-expanded', willOpen ? 'true' : 'false');
	};

	$cards.on('click', function () {
		toggle($(this));
	});

	// role="button" の要素なので Enter / Space でも開閉できるようにする
	$cards.on('keydown', function (e) {
		if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
			e.preventDefault();
			toggle($(this));
		}
	});

});



// アコーディオンの起動 // Activate the accordion
jQuery(function($) {


	if ( $('dl.accordion dt').length > 0 ) {

		$("dl.accordion dt").click(function(){
			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

// ドロワーメニュー // Drawer menu
jQuery(function($) {

	var $toggle = $('#toggle');

	if ($toggle.length > 0) {

		var $nav = $('.l-header-nav');
		var $layer = $('#drawer_layer');

		function openDrawer() {
			// 背面の慣性スクロールを止める // Pause the inertia scrolling behind the drawer
			if (window.lenis) {
				window.lenis.stop();
			}
			$toggle.addClass('toggle_active');
			$layer.fadeIn();
			$('body').addClass('drawer_open');
			$nav.addClass('is_open').removeClass('is_close');
		}

		function closeDrawer() {
			// 慣性スクロールを再開する // Resume the inertia scrolling
			if (window.lenis) {
				window.lenis.start();
			}
			$toggle.removeClass('toggle_active');
			$layer.fadeOut();
			$('body').removeClass('drawer_open');
			$nav.removeClass('is_open').addClass('is_close');

			// 開いていたサブメニューを閉じる（インラインのdisplayを消してCSSに戻す）
			// Collapse open sub menus (drop the inline display so CSS takes over again)
			$nav.find('.l-header-nav__subToggle').attr('aria-expanded', 'false');
			$nav.find('.l-header-nav__sub').stop(true, true).css('display', '');
		}

		$toggle.on('click', function () {
			if ($toggle.hasClass('toggle_active')) {
				closeDrawer();
			} else {
				openDrawer();
			}
		});

		$layer.on('click', closeDrawer);

		// サブメニューの開閉 // Toggle sub menu
		$nav.on('click', '.l-header-nav__subToggle', function () {
			var $btn = $(this);
			var isOpen = $btn.attr('aria-expanded') === 'true';

			$btn.attr('aria-expanded', isOpen ? 'false' : 'true');
			$btn.siblings('.l-header-nav__sub').stop(true, true).slideToggle(300);
		});

		// エリア内リンク用 // For links within an area
		$nav.on('click', 'a', function () {
			// if (window.innerWidth <= 768) {
			if ($toggle.is(':visible')) {
				closeDrawer();
			}
		});

		// 開いたままPC幅になった時は閉じる（body固定が残らないように）
		// Close when resized up to PC width so the body scroll lock is released
		$(window).on('resize', function () {
			if ($toggle.hasClass('toggle_active') && !$toggle.is(':visible')) {
				closeDrawer();
			}
		});
	}

});


// 沿革の年ナビ 表示中の年をハイライト // Highlight the year currently in view (company history)
jQuery(function($) {

	var $navItems = $('.p-companyHistory__navItem');

	if ($navItems.length > 0) {

		var $items = $('.p-companyHistory__item');

		function updateHistoryNav() {
			// 画面上部から30%の位置を基準に、通過済みの最後の年をアクティブにする
			// Activate the last year passed, measured at 30% from the top of the viewport
			var border = $(window).scrollTop() + $(window).height() * 0.3;
			var current = $items.first().data('year');

			$items.each(function() {
				if ($(this).offset().top <= border) {
					current = $(this).data('year');
				}
			});

			$navItems.removeClass('--current')
				.filter('[data-year="' + current + '"]').addClass('--current');
		}

		updateHistoryNav();
		$(window).on('scroll resize', updateHistoryNav);
	}

});


// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function($) {

	if ( $('#pageplugin').length > 0 ) {

		var windowWidth = $(window).width();
		var htmlStr = $('#pageplugin').html();
		var timer = null;
		$(window).on('resize',function() {
			var resizedWidth = $(window).width();
			if(windowWidth != resizedWidth && resizedWidth < 500) {
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('#pageplugin').html(htmlStr);
					window.FB.XFBML.parse();
			   		//window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
					var windowWidth = $(window).width();
				}, 500);
			}
		});
	}
});

jQuery(function ($) {
//二重送信抑制
	let submitBtn = $("input[type='submit'].wpcf7-submit");
	submitBtn.click(function () {
		$(this).css('pointer-events', 'none');
		$(this).css('opacity', '0.5');
	})
	// 入力項目にエラーがあったらボタン復活
	document.addEventListener('wpcf7invalid', function () {
		submitBtn.css('pointer-events', 'auto');
		submitBtn.css('opacity', '1');
	}, false);

});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js-accordion-title').forEach(function(title) {
    title.addEventListener('click', function() {
      title.classList.toggle('is-open');
      var content = title.nextElementSibling;
      content.classList.toggle('is-open');
    });
  });
});

